const QWrapper = (props) => {
    return <div className='w-100 mb-4'>{props.children}</div>
}

export default QWrapper